import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { userLst } from 'src/app/models/userLst';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { CreateEditDeportistaComponent } from '../create-edit-deportista/create-edit-deportista.component';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { EmpresaService } from 'src/app/services/empresa.service';



@Component({
  selector: 'app-index-deportistas-alto-rendimiento',
  templateUrl: './index-deportistas-alto-rendimiento.component.html',
  styleUrls: ['./index-deportistas-alto-rendimiento.component.scss']
})
export class IndexDeportistasAltoRendimientoComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  permiteExtencion = false;
  searchString: string = '';
  public lstDisciplinas: any;
  public lstPlanes: any;
  public lstDeportistas: userLst[];
  public disciplinaSelect: any;
  public ordenamientoSelect = '0';
  public hoy = new Date();
  public clubSelect: any;
  public lstClubes: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public userSvc: UserService,
    public disciplinaSvc: DisciplinaService,
    public empresaSvc: EmpresaService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: userLst[] = [];
    this.displayedColumns = [
      'nombre',
      'disciplina',
      'fecha',
      'club',
      'altoRendimiento',
    ];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;

    this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
      console.log(disLst);
      this.lstDisciplinas = disLst;
      this.getUsers(0, 10);
    });
  }

  ngOnInit(): void {
/*     this.planSvc.GetPlanesDropDown().subscribe((disLst) => {
      console.log(disLst);
      this.lstPlanes = disLst;
    }); */

    this.empresaSvc.getEmpresasDropdown().subscribe((clubLst) => {
      console.log(clubLst);
      this.lstClubes = clubLst;
    });

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getUsers(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.userSvc
      .getDeportistasAltoRendimiento(
        page,
        numReg,
        this.searchString,
        this.disciplinaSelect,
        this.clubSelect,
      )
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<any>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.lstDeportistas = result[0];
        this.isLoadingResults = false;

        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getUsers(event.pageIndex, event.pageSize);
  }

  cambioDiscipinaBuscar() {
    this.getUsers(this.pageIndex, this.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getUsers(0, 10);
  }

  openDialogCreateUser(): void {
    let dialogRef = this.dialog.open(CreateEditDeportistaComponent, {
      data: null,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por creacion');
        this.getUsers(this.pageIndex, this.pageSize);
      }
    });
  }

  edit(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(CreateEditDeportistaComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        //  this.getUsers(this.pageIndex, this.pageSize);
      }
    });
  }

  validarFechas(fecha: any): boolean {
    return Date.parse(fecha) >= this.hoy.getTime();
  }

}
